
/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';

export interface GetProfilePageRequest {
    token: string;
}

/**
 * 
 */
export class GetProfilePageApi extends runtime.BaseAPI {

    /**
     * Redirect to a profile page from a given access token
     * Get a profile page
          */
    async getProfilePageRaw(requestParameters: GetProfilePageRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling getProfilePage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/search/profile/{token}`.replace(`{${"token"}}`, encodeURIComponent(String(requestParameters['token']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Redirect to a profile page from a given access token
     * Get a profile page
          */
    async getProfilePage(requestParameters: GetProfilePageRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.getProfilePageRaw(requestParameters, initOverrides);
    }

}
